import { lazy } from 'react';
// @ts-ignore
export const EditScreenAsync = lazy(() => import('./EditScreen.tsx'));
